// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__24QO6","title":"style_title__2dfpv","item":"style_item__1b7Zw"};